export class ProfileRequest{
    profilesId: number;
    
    
    constructor( profilesId: number,
        ){
            this.profilesId= profilesId;
        }
    
    }